import { LocationSearchConstants } from './locationSearch.constants'
import { ILocationSearchAction, ILocationSearchState } from './locationSearch.types'

export const initialLocationSearchState: ILocationSearchState = {
  errorMsgsMap: {},
  enableLocationSearch: false,
}

export function locationSearchReducer(
  state: ILocationSearchState = initialLocationSearchState,
  action: ILocationSearchAction
): ILocationSearchState {
  switch (action.type) {
    case LocationSearchConstants.SET_ENABLE_LOCATION_SEARCH:
      return { ...state, enableLocationSearch: action.enableLocationSearch }
    case LocationSearchConstants.SET_ERROR_MSGS_MAP:
      return { ...state, errorMsgsMap: action.errorMsgsMap }
    case LocationSearchConstants.RESET_LOCATION_SEARCH_STATE:
      return { ...state, errorMsgsMap: {} }
    default:
      return state
  }
}
